export default __webpack_public_path__ + "static/media/emergencyIcon (2).5b77065f.svg";